import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardHeader,
  CardBody,
  ListGroup,
  ListGroupItem,
  CardFooter,
  Row,
  Col,
  FormSelect
} from "shards-react";

class TopReferrals extends React.Component {
  render() {
    const { vacationforme } = this.props;
    console.log("this is the propos", this.props)
    return (
      <Card small>
        <CardHeader className="border-bottom">
          <h6 className="m-0">Best Vacations</h6>
          <div className="block-handle" />
        </CardHeader>

        <CardBody className="p-0">
          <ListGroup small flush className="list-group-small">
            {vacationforme.map((vacation ) => (
              <ListGroupItem  className="d-flex px-3">
                <span className="text-semibold text-fiord-blue">
                  {vacation.title}
                </span>
                <span className="ml-auto text-right text-semibold text-reagent-gray">
                  {vacation.followers}
                </span>
              </ListGroupItem>
            ))}
          </ListGroup>
        </CardBody>

        <CardFooter className="border-top">
          <Row>
            {/* Time Span */}
            <Col>
              <FormSelect
                size="sm"
                value="last-week"
                style={{ maxWidth: "130px" }}
                onChange={() => {}}
              >
                <option value="This Year">Last Week</option>
              </FormSelect>
            </Col>

            {/* View Full Report */}
            <Col className="text-right view-report">
              {/* eslint-disable-next-line */}
              <a href="#">Full report &rarr;</a>
            </Col>
          </Row>
        </CardFooter>
      </Card>
    );

  }
}

export default TopReferrals;
